import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';

interface ChatBox {
    id: number;
    name: string;
    avatar: string;
}

interface ChatContextType {
    chatBoxes: ChatBox[];
    addChatBox: () => void;
    removeChatBox: (index: number) => void;
}

const ChatContext = createContext<ChatContextType>({
	chatBoxes     : [],
	addChatBox    : () => '',
	removeChatBox : () => ''
});

const chatData: ChatBox[] = [
	{ id: 1, name: 'Starwin', avatar: 'https://moviegalleri.net/wp-content/uploads/2020/02/Vijay-Master-Movie-Stills-HD-4afc34c.jpg' },
	{ id: 2, name: 'Veera Raghavan', avatar: 'https://pbs.twimg.com/media/FSxaU7nacAED4Tz.jpg:large' },
	{ id: 3, name: 'Jeevan', avatar: 'https://images.indianexpress.com/2024/09/Sequel-to-Vijay-and-Venkat-Prabhus-GOAT-on-the-cards_.jpg' },
	{ id: 4, name: 'Gandhi', avatar: 'https://1847884116.rsc.cdn77.org/tamil/home/goat732024m.jpg' },
	{ id: 5, name: 'Joseph kuruvila', avatar: 'https://th.bing.com/th/id/OIP.mXElIAPMZKMvLK9n2iMvggHaFX?rs=1&pid=ImgDetMain' },
	{ id: 6, name: 'Parthiban', avatar: 'https://th.bing.com/th/id/OIP.krMiJJavnIqlsXyEoEjWbAHaKP?rs=1&pid=ImgDetMain' }
];

export const ChatProvider = ({ children }: { children: ReactNode }) =>
{
	const [ visibleIndexes, setVisibleIndexes ] = useState<number[]>([ 0, 1 ]);
	const [ maxVisible, setMaxVisible ] = useState(0);

	const isLaptop = useMediaQuery('(min-width: 1024px)');
	const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)');
	const isMobile = useMediaQuery('(max-width: 767px)');

	useEffect(() =>
	{
		if (isLaptop)
		{
			setMaxVisible(2);
		}
		else if (isTablet)
		{
			setMaxVisible(1);
		}
		else if (isMobile)
		{
			setMaxVisible(1);
		}
	}, [ isLaptop, isTablet, isMobile ]);

	// Ensure only the allowed number of chat boxes is visible
	useEffect(() =>
	{
		setVisibleIndexes((prevIndexes) => prevIndexes.slice(0, maxVisible));
	}, [ maxVisible ]);

	const addChatBox = () =>
	{
		setVisibleIndexes((prevIndexes) =>
		{
			if (prevIndexes.length === 0)
			{
				return [ 0 ];
			}

			if (prevIndexes.length < maxVisible)
			{
				const nextIndex = (prevIndexes[prevIndexes.length - 1] + 1) % chatData.length;

				return [ ...prevIndexes, nextIndex ];
			}

			return prevIndexes.map((index) => (index + 1) % chatData.length);
		});
	};

	const removeChatBox = (index: number) =>
	{
		setVisibleIndexes((prevIndexes) => prevIndexes.filter((_, i) => i !== index));
	};

	const chatBoxes = visibleIndexes.map((index) => chatData[index]);

	return (
		<ChatContext.Provider value={{ chatBoxes, addChatBox, removeChatBox }}>
			{children}
		</ChatContext.Provider>
	);
};

export const useChat = () => useContext(ChatContext);
